import React, { useContext, Fragment } from "react";
import { Tooltips, getTooltipShortcut } from '../../ui/components/Tooltips/Tooltips';
import styles from './Toolbar.less';
import { AppSettingsContext } from '../../context/config';
export default function Toolbar({ items, onClick }) {
    const appSettings = useContext(AppSettingsContext);
    if (!appSettings) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Tooltips, null,
        React.createElement("div", { className: styles.root }, items.map(item => React.createElement(Fragment, { key: item.id },
            React.createElement("button", { className: "icon", disabled: item.disabled ?? false, onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClick?.(item.id);
                    setTimeout(() => item.onClick(), 100);
                }, "data-tooltip": item.title + getTooltipShortcut(item.id, appSettings.keybindings) },
                item.icon,
                " ",
                item.label && React.createElement("span", null, item.label)),
            item.delimiter && React.createElement("i", null))))));
}
